"use strict";

function Header() {
  return {
    submenuMoreShown: false,
    isNavigationDrawerShown: false,
    isNavigationDrawerSubnavShown: false,
    upperBanner: null,
    debouncedAdjustPosition: null,
    mounted() {
      this.elDropdownTitle = document.querySelector('.dropdown-title');
      this.elDropdownMenu = document.querySelector('.dropdown-menu');
      this.elHamburgerButton = document.querySelector('.item_hamburger_menu');
      this.elNavigationDrawer = document.querySelector('.navigation__drawer');
      this.subnavigations = document.querySelectorAll('.navigation_drawer__item .drawer_subnav__wrap');
      this.debouncedAdjustPosition = window.debounce(() => {
        this.adjustDrawerPosition(this.isNavigationDrawerSubnavShown);
      }, 5);
      window.addEventListener('load', () => {
        if (!window.isMob) {
          this.adjustDrawerPosition(true);
        }
      });
    },
    trackDropdownEvent(event) {
      const withinBoundaries = event.composedPath().includes(this.elDropdownMenu) || event.composedPath().includes(this.elDropdownTitle);
      if (!withinBoundaries) {
        this.elDropdownMenu.style.display = 'none';
        this.submenuMoreShown = false;
        window.removeEventListener('click', this.trackDropdownEvent);
      }
    },
    toggleSubmenuDropdown() {
      this.submenuMoreShown = !this.submenuMoreShown;
      if (this.submenuMoreShown) {
        this.elDropdownMenu.style.display = 'block';
        window.addEventListener('click', this.trackDropdownEvent);
      } else {
        this.elDropdownMenu.style.display = 'none';
        window.removeEventListener('click', this.trackDropdownEvent);
      }
    },
    closeActiveSubnavSiblings(elActiveDrawerItem) {
      const elActiveSiblings = this.elNavigationDrawer.getElementsByClassName('navigation_drawer__item is-active');
      Array.from(elActiveSiblings).forEach(elDrawerItem => {
        if (elDrawerItem !== elActiveDrawerItem) elDrawerItem.classList.remove('is-active');
      });
    },
    trackDrawerEvent(event) {
      const withinBoundaries = event.composedPath().includes(this.elNavigationDrawer) || event.composedPath().includes(this.elHamburgerButton);
      if (!withinBoundaries) {
        this.elNavigationDrawer.classList.remove('is-active');
        this.isNavigationDrawerShown = false;
        this.closeActiveSubnavSiblings();
        this.isNavigationDrawerSubnavShown = false;
        window.removeEventListener('click', this.trackDrawerEvent);
      }
    },
    toggleNavigationDrawer() {
      this.isNavigationDrawerShown = !this.isNavigationDrawerShown;
      if (this.isNavigationDrawerShown) {
        window.addEventListener('click', this.trackDrawerEvent);
      } else {
        this.closeActiveSubnavSiblings();
        window.removeEventListener('click', this.trackDrawerEvent);
      }
      this.elNavigationDrawer.classList.toggle('is-active');
    },
    showDrawerSubitems(event) {
      this.isNavigationDrawerSubnavShown = !this.isNavigationDrawerSubnavShown;
      this.elActiveDrawerItem = event.target.closest('.navigation_drawer__item');
      this.closeActiveSubnavSiblings(this.elActiveDrawerItem);
      this.elActiveDrawerItem.classList.toggle('is-active');
      if (!window.isMob) this.adjustDrawerPosition(this.isNavigationDrawerSubnavShown);
    },
    adjustDrawerPosition(isActive) {
      this.upperBanner = document.querySelector('.js_spaRemove > #upper');
      const topPosition = Math.max(this.elNavigationDrawer.getBoundingClientRect().top, 0);
      this.subnavigations.forEach(subnav => {
        subnav.style.top = `${topPosition}px`;
      });
      if (isActive) {
        if (this.upperBanner) window.addEventListener('scroll', this.debouncedAdjustPosition, {
          passive: true
        });
        window.addEventListener('resize', this.debouncedAdjustPosition);
      } else {
        window.removeEventListener('scroll', this.debouncedAdjustPosition, {
          passive: true
        });
        window.removeEventListener('resize', this.debouncedAdjustPosition);
      }
    }
  };
}
window.PetiteVue.createApp({
  Header
}).mount();